import type { FC, ReactNode } from 'react';

interface Props {
    // TextField picks its suffix child by looking for this prop.
    suffix: boolean;
    children: ReactNode;
}

// Warp's `suffix` component classes spelled out: they are plain Uno utilities, and Uno only
// generates what it can find as literal text in the source.
const SUFFIX = 'absolute top-0 bottom-0 right-0 w-40 flex justify-center items-center bg-transparent s-text-subtle';

export const IconAffix: FC<Props> = ({ children }) => <div className={SUFFIX}>{children}</div>;
